import { Countries, CountryCallingCodes } from 'libphonenumber-js/types';
import { MetadataJson } from 'libphonenumber-js/core';
import libPhoneNumberMetaDataJson from './libphonenumber-metadata.json';

export default {
  /* eslint-disable-next-line camelcase */
  country_calling_codes: libPhoneNumberMetaDataJson.country_calling_codes as CountryCallingCodes,
  countries: libPhoneNumberMetaDataJson.countries as Countries,
  version: libPhoneNumberMetaDataJson.version,
  nonGeographic: libPhoneNumberMetaDataJson.nonGeographic,
} as MetadataJson;
